export default __webpack_public_path__ + "static/media/add.c8dc7667e40d7b9f1b446d07449cab9a.svg";